import React from 'react';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

function DateOfJoinReport() {
  const location = useLocation();
  const { state } = location;
  const { adminmob, branchId } = state;
 const navigate = useNavigate();
const [AttData, setAttData] = React.useState({});
  const [schoolData, setSchoolData] = useState(null); 
  const udiseNumber = localStorage.getItem("udiseNumber");

  const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');
  
        useEffect(() => {
                   const storedLanguage = localStorage.getItem('language') || 'English';
                   setLanguage(storedLanguage);
                 }, []);

  React.useEffect(() => {
    const fetchData = async () => {
      const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/AttendanceData/${udiseNumber}/AttData.json`;

      try {
        const response = await fetch(url);
        const data = await response.json();

        if (data) {
          setAttData(data);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [adminmob, branchId]);

    useEffect(() => {
            fetchSchoolData(); 
          }, );

  const handleDateOfJoinReport = () => {
    const dateOfJoinReportData = Object.keys(AttData).map((mobile) => ({
      mobile,
      name: AttData[mobile].Name,
      dateOfJoin: AttData[mobile].DateOfJoin,
    }));
    console.log("dateOfJoinReportData",dateOfJoinReportData);
    
    // You can now use the dateOfJoinReportData to generate the report
    console.log(dateOfJoinReportData);
  };

  const handleClose = () => {
    navigate(-1); 
  };

  const fetchSchoolData = () => {
    const firebaseDatabaseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`;
  
    fetch(firebaseDatabaseUrl)
      .then(response => response.json())
      .then(data => {
        setSchoolData(data); 
      })
      .catch(error => {
        console.error('Error fetching school data from Firebase:', error);
      });
  };
  const handlePrint = () => {
    const printContent = document.querySelector('.modal-content');
  
    if (printContent) {
      const cloneContent = printContent.cloneNode(true);
  
      const schoolName = cloneContent.querySelector('p'); 
      const otherDetails = cloneContent.querySelectorAll('p'); 
  
      otherDetails.forEach((p, index) => {
        if (index !== 0) { 
          p.style.fontWeight = 'normal'; 
        }
      });
      
      if (schoolName) {
        schoolName.innerHTML = `<h5 style="font-size: 16px; margin-top: 10px;">${schoolData.schoolName}</h5>`; // Increase the font size and set top margin
      }
  
      const printWindow = window.open('', '', 'height=600,width=800');
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Modal Content</title>
            <style>
              @page {
                size: A4 portrait;
                margin: 3mm;
              }
              body {
                font-family: Arial, sans-serif;
                margin: 0; /* Remove body margin */
              }
              .modal-content {
                margin: 20px; /* Add margin to the modal content */
              }
              thead {
                            background-color: #F0F0F0; /* Set very light gray background color for <thead> */

              }
                            .title-print{
                            padding-top:0;
                            }
            </style>
          </head>
          <body>
            ${cloneContent.outerHTML} <!-- Include the modified outer HTML of the modal content -->
          </body>
        </html>
      `);
      printWindow.document.close(); 
      printWindow.focus(); // Focus the new window
      printWindow.print(); // Trigger print
      printWindow.close(); // Close the print window after printing
    } else {
      console.error('Print content not found');
    }
  };

  return (
    <div className='main-content-of-page' style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      padding: '20px', 
    }}>
     <div style={{ 
  width: '70%', 
  border: '1px solid black', 
  boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)', 
  padding: '14px 18px', 
   backgroundColor: '#f0f0f0', 
  minHeight:'700px' 
}}>
<h1 style={{ 
  fontSize: '24px', 
  fontWeight: 'bold', 
  color: '#333',
  marginBottom: '20px',
  display: 'flex', 
  justifyContent: 'space-between',
  alignItems: 'center',
 
}}> 
  <button style={{ 
    backgroundColor: '#dc3545', 
    color: '#fff', 
    border: 'none', 
    borderRadius: '5px', 
    cursor: 'pointer', 
    fontSize: '20px', 
    fontWeight: 'bold',
     marginLeft:'1050px'
  }} onClick={handleClose}> 
    X
  </button>
</h1>

<button style={{ 
   backgroundColor:'#1B4332',
  color: 'white', 
  border: 'none', 
  borderRadius: '5px', 
  cursor: 'pointer', 
  fontSize: '15px', 
  fontWeight: 'bold',
  marginBottom: '20px',
  marginLeft:'950px'
}} onClick={handlePrint}> 
  Print Report
</button>
<div className='modal-content'>
<table style={{ 
  width: '100%', 
  borderCollapse: 'collapse', 
  border: '1px solid black' 
}}>
  <thead>
                    {schoolData && (
                      <tr>
                        <th colSpan="4" style={{
                          color: 'black',
                          padding: '5px',
                          borderRadius: '10px 10px 0 0',
                          textAlign: 'center',
                          lineHeight: '0.5',
                          border: '1px solid black',
                          fontSize: '13px', 
                           paddingBottom:'30px'
                        }}>
                          <p><strong><h5> {schoolData.schoolName}</h5></strong></p>
                          <p>{schoolData.sansthaName}</p>
                          <p>{language === "English" ? "Taluka:" : "तालुका:"} {schoolData.taluka} , {language === "English" ? "Jilha:" : "जिल्हा:"} {schoolData.jilha} </p>
                          <p style={{marginBottom:'25px'}}>{language === "English" ? "Mobile Number:" : "मोबाइल नंबर:"} {schoolData.mobileNumber} , {language === "English" ? "Email:" : "ईमेल:"} {schoolData.email}</p>
                          <span className="title-print" style={{ border:'1px solid black',textAlign: 'center',width:'310px',margin:'auto',backgroundColor:'black',color:'white',borderRadius:'5px', padding:'5px', marginTop:'25px', fontSize:'15px' }}>{language === "English" ? "Date of Join Report  " : "रुजु झालेल्या तारखेचा अहवाल"}</span>
                        </th>
                      </tr>
                    )}
                    <tr>
      <th style={{ 
        padding: '10px', 
        border: '1px solid black', 
        textAlign: 'center',
        backgroundColor: '#ecf0f1',
        color: 'black', 
      }}>{language === "English" ? "Sr No." : "अनु.क्र."}</th>
      <th style={{ 
        padding: '10px', 
        border: '1px solid black', 
        textAlign: 'center',
        backgroundColor: '#ecf0f1',
        color: 'black', 
      }}>{language === "English" ? "Name" : "नाव"}</th>
      <th style={{ 
        padding: '10px', 
        border: '1px solid black', 
        textAlign: 'center',
        backgroundColor: '#ecf0f1',
        color: 'black',
      }}>{language === "English" ? "Mobile Number" : "मोबाईल नंबर"}</th>
      <th style={{ 
        padding: '10px', 
        border: '1px solid black', 
        textAlign: 'center',
        backgroundColor: '#ecf0f1',
        color: 'black',
      }}>{language === "English" ? "Date of Join" : "रुजु झालेली तारीख"}</th>
      </tr>
  </thead>
  <tbody>
    {Object.keys(AttData).map((mobile, index) => (
      <tr key={mobile} style={{ 
        backgroundColor: '#fff', 
        color: '#333', 
        fontSize: '16px' 
      }}>
        <td style={{ 
          padding: '10px', 
          border: '1px solid black', 
          textAlign: 'center' 
        }}>{index + 1}</td>
        <td style={{ 
          padding: '10px', 
          border: '1px solid black', 
          textAlign: 'center' 
        }}>{AttData[mobile].Name}</td>
        <td style={{ 
          padding: '10px', 
          border: '1px solid black', 
          textAlign: 'center' 
        }}>{mobile}</td>
        <td style={{ 
          padding: '10px', 
          border: '1px solid black', 
          textAlign: 'center' 
        }}>{AttData[mobile].Currentteacher?.DOJ || '-'}</td>
      </tr>
    ))}
  </tbody>
</table>

</div>
</div>
</div>
);
}

export default DateOfJoinReport;